import React, {useEffect, useState} from 'react';
import TemplatesList from "./List";
import {useOrganizationService, useTemplateService} from '../../services';
import DrawerTemplates from "./AddUpdateTemplate";
import CustomButton from '../../components/common/CustomButton';
import {useJwt} from "../../helpers/common";
import {useSideNavContext} from '../../context/SideNavContext';
import {HiPlusCircle} from 'react-icons/hi';
import { Breadcrumb } from 'flowbite-react';
import { Link } from 'react-router-dom';
import BreadcrumbItem from 'flowbite-react/lib/esm/components/Breadcrumb/BreadcrumbItem';
import TooltipWrapper from '../../shared/atoms/TooltipWrapper';

const Templates = () => {
  const JWTdata: any = useJwt()
  const org_id = JWTdata.org_id;
  const { isOpenOnSmallScreens } = useSideNavContext();
  const { fetchAllTemplates } =  useTemplateService();

  const [toggleCreateModal,setToggleCreateModal] = useState(false)
  const [payloadData,setPayloadData] = useState({})

  useEffect(()=>{
    fetchAllTemplates()

 

    return ()=>{
      setPayloadData({})
      setToggleCreateModal(false)
    }
  },[org_id])

  const handleCreateButtonClick = () => {
    setPayloadData({})
    setToggleCreateModal(true)
  }

  const handleEditTemplate = (payload?:any) => {
    setToggleCreateModal(true)
    setPayloadData(payload)
  }

  const containerWidth = !isOpenOnSmallScreens ? 'calc(100vw - 255px)' : 'calc(100vw - 65px)';

  return (
    <div
      className="row dark:bg-tertiary-dark bg-tertiary-light w-full h-[100vh] !overflow-y-auto relative flex flex-col"
      style={{ width: containerWidth }}
    >
      <div className="flex items-center justify-between w-full py-2 px-2 sm:px-4 bg-light-surfacePrimary dark:bg-secondary-dark border-b border-light-border-default dark:border-gray-700 min-h-[65px] max-h-[65px] gap-2">
        <div className="flex items-center min-w-0 flex-1  overflow-hidden truncate">
          <Breadcrumb className="min-w-0 flex flex-nowrap items-center">
            <BreadcrumbItem>
              <Link to={"/workitems"} className="breadcrumb-link">
                Work Items
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem className="text-light-text-secondary dark:text-gray-400">
              Templates
            </BreadcrumbItem>
          </Breadcrumb>
            <CustomButton
              onClick={handleCreateButtonClick}
              className="ml-auto flex items-center gap-2 bg-primary-light hover:bg-primary-dark text-white px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
            >
              <HiPlusCircle className="text-base" />
          <TooltipWrapper placement='bottom'  message="Create Template from existing work items">
              <span>Create Template</span>
          </TooltipWrapper>
            </CustomButton>
        </div>
      </div>

      <div className={`overflow-x-auto mt-4 px-10 flex-1`}>
        <TemplatesList handleEditTemplate={handleEditTemplate} />
      </div>

      <div className="h-10"></div>

      <DrawerTemplates
        toggleCreateModal={toggleCreateModal}
        setToggleCreateModal={setToggleCreateModal}
        payloadData={payloadData}
        setPayloadData={setPayloadData}
      />
    </div>
  );
}

export default Templates;